import { gql } from '@apollo/client'

import { ACTION_COMPLETE_FRAGMENT } from './ActionCompleteFragment'
import { ACTION_NOTE_FRAGMENT } from './ActionNoteFragment'
import { SUB_ACTION_FRAGMENT } from './SubActionFragment'

export const FULL_ACTION_FRAGMENT = gql`
  fragment FullAction on Action {
    title
    description
    dueDate
    dueDateTime
    actionType
    id
    status
    createdBy {
      id
      firstName
      lastName
      email
    }
    generatorStores {
      id
      location {
        id
        name
      }
    }
    actionGenerator {
      id
      repeatSchedule
      endDate
    }
    store {
      id
      location {
        id
        name
        address1
        city
        state
        postalCode
      }
    }
    notes {
      ...ActionNote
    }
    closedBy {
      id
    }
    actionGroup {
      id
      title
    }
    actionShift {
      id
      title
    }
    completions {
      ...ActionComplete
    }
    parentAction {
      id
      title
    }
    aiImageCheck
    notifyOnFailure
    notifyOnSuccess
    notifyActiveManager
    peopleToNotify {
      id
      firstName
      lastName
      email
    }
    subActions {
      ...SubAction
    }
  }
  ${SUB_ACTION_FRAGMENT}
  ${ACTION_COMPLETE_FRAGMENT}
  ${ACTION_NOTE_FRAGMENT}
`
